import { render, staticRenderFns } from "./EmailListView.vue?vue&type=template&id=0fa9a2bc&"
import script from "./EmailListView.vue?vue&type=script&lang=js&"
export * from "./EmailListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa9a2bc')) {
      api.createRecord('0fa9a2bc', component.options)
    } else {
      api.reload('0fa9a2bc', component.options)
    }
    module.hot.accept("./EmailListView.vue?vue&type=template&id=0fa9a2bc&", function () {
      api.rerender('0fa9a2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/EmailListView.vue"
export default component.exports